export default [
    {
        id: 0,
        code: "kz",
        bonus: [
            "bronze_reward",
        ]
    },
    {
        id: 1,
        code: "mn",
        bonus: []
    },
    {
        id: 2,
        code: "kg",
        bonus: [
            "bronze_reward",
        ]
    },
  ];
  